import React, { useState, useEffect, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import Typography from '@mui/material/Typography';
import { motion } from 'framer-motion';
import TextField from '@mui/material/TextField';
import { Divider, FormControl, Grid, Paper, Tooltip, CircularProgress } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import moment from 'moment';
import { formatter, constants, changeCurrency, invoiceTicketHaulingRate } from '../../../../../constants';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ReactToPrint from 'react-to-print';
import ModelInvoiceEmail from '../../Uninvoiced/Modals/ModelInvoiceEmail';
import store from 'app/store';
import axios from 'axios';
import { getDataFromS3 } from 'app/main/CompanyList/companyFunctions';
import FuseLoading from '@fuse/core/FuseLoading';
import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import PaymentDialog from './ViewPaymentModalShow';
import client from 'client';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import { orderBy } from 'lodash';
import { useTranslation } from 'react-i18next';
import OriginalJobLabel from 'app/main/loadz/components/OriginalJobLabel';
import { paymentVoidReturnLabel, VOID_RETURN_BG, VOID_RETURN_COLOR } from './paymentStatus';

const TODAY = moment();

/** Safe wait-hours display; avoids NaNH when value is missing/invalid. */
const formatWaitHours = (value) => {
  const hours = Number(value);
  return `${Number.isFinite(hours) ? hours.toFixed(2) : '0.00'}H`;
};

const safeWaitHoursFromRate = (waitCRTotal, waitrate) => {
  const rate = Number(waitrate);
  const total = Number(waitCRTotal) || 0;
  if (!(rate > 0)) return '0.00';
  const hours = total / rate;
  return Number.isFinite(hours) ? hours.toFixed(2) : '0.00';
};

const steps = [
  {
    label: 'Opend',
  },
  {
    label: 'Create an ad group',
  },
  {
    label: 'Create an ad',
  },
];

const item = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0 },
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const token = localStorage.token;

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

function ticketFuelSurchargeAmount(ticket) {
  if (ticket?.fuel_surcharge == null) return 0;
  return Number(ticket.fuel_surcharge.amount) || 0;
}

function jobFuelSurchargeTotal(job) {
  return (job?.batches || []).reduce(
    (sum, batch) =>
      sum +
      (batch?.info || []).reduce(
        (ticketSum, ticket) => ticketSum + ticketFuelSurchargeAmount(ticket),
        0
      ),
    0
  );
}

function ModalGenerateInvoices({
  openModalInvoices,
  info,
  tickets,
  logo,
  compNameData,
  ClientName,
  compacctNumSub,
  user,
  prop_data = null,
  isOwnerOpsView = false,
  onInvoiceUpdated = null,
}) {
  const [open, setOpen] = useState(false);
  const [uniqueJobs, setUniqueJobs] = useState([]);
  const [toTable, setTotable] = useState([]);
  const [dataForPDF, setDataWithSignature] = useState([]);
  const [logoCompany, setLogoCompany] = useState('');
  const [notes, setNotes] = useState();
  const [discounts, setDiscounts] = useState(0);
  const [terms, setTerms] = useState(0);
  const [dateStarted, setDateStarted] = useState(null);
  const [compacct, setCompacct] = useState('');
  const [compName, setCompName] = useState(null);
  const [infoData, setInfoData] = useState(null);
  const [blobLogoForUNVoice, setBlobLogoForUNVoice] = useState(null);
  const [loaderData, setLoaderData] = useState(true);
  const [isViewPaymentOpened, setIsViewPaymentOpened] = useState(false);
  const [allPayment, setAllPayment] = useState(null);
  const [emailForPayment, setEmailForPayment] = useState(null);
  const [viewPaymentData, setViewPaymentData] = useState(null);
  const [invoiceNumber, setInvoiceNumber] = useState(0);
  const [paymentReceiptData, setPaymentReceiptData] = useState(null);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation('navigation');
  const rateColumnLabel = isOwnerOpsView ? t('OWNER_OPERATOR_UNIT_COST_RATE') : t('RATE');
  const handleOpen = (open) => {
    setOpen(!open);
  };
  const openViewPaymentDialog = (element) => {
    if (allPayment && allPayment.length > 0) {
      const specific_payment = allPayment.filter((pay) => pay.id == element.pdid);

      setPaymentReceiptData(specific_payment[0].payments);
    }

    setIsViewPaymentOpened(true);
    setViewPaymentData(element);
  };
  const closeDialog = () => {
    setIsViewPaymentOpened(false);
  };

  useEffect(() => {
    openModalInvoices.current = handleOpen;
  }, []);

  useEffect(async () => {
    if (open) {
      let compName = prop_data ? prop_data?.compname : user?.company?.compname;

      if (compNameData) {
        compName = compNameData;
      }

      setCompName(compName);
      setCompacct(prop_data ? prop_data?.compacctnum : user?.company?.compacctnum);
    }
  }, [open]);

  useEffect(() => {
    setTotable([]);

    if (open && compacct) {
      getData();
    }
  }, [compacct, open]);

  const getImage = async (url) => {
    const awsImage = await fetch(`${constants.URLLOCAL}/aws/get`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        token: `${token}`,
      },
      body: JSON.stringify({
        key: logo ? logo : url,
      }),
    });
    const img = await awsImage.json();

    return img.data?.fileLocation ? img.data.fileLocation : null;
  };

  const _showMessage = (message) => {
    dispatch(
      showMessage({
        message: message, //text or html
        autoHideDuration: 6000, //ms
        anchorOrigin: {
          vertical: 'top', //top bottom
          horizontal: 'right', //left center right
        },
        variant: 'error', //success error info warning null
      })
    );
  };

  const getData = async () => {
    try {
      setLoaderData(true);
      let _rows = [];
      setInfoData(info);
      const invoiceId = info?.id ?? info?.invoice_id ?? null;
      // OwnerOps OOP preview must use the -OP compacct, not the parent session company
      const invoiceCompacct =
        (typeof compacctNumSub === 'string' && compacctNumSub.includes('-OP')
          ? compacctNumSub
          : null) ||
        (prop_data ? prop_data?.compacctnum : user?.company?.compacctnum);
      const jobs = await client.post(`/invoices/tickets-invoices/${invoiceCompacct}`, {
        tickets,
        ...(invoiceId ? { recalculateInvoiceId: invoiceId } : {}),
      });
      const jsonJobs = jobs.data;
      if (jsonJobs && jsonJobs.length > 0) {
        getEmailLogsForCustomer(jsonJobs[0].customer.id);
        if (jsonJobs[0] && jsonJobs[0].customer && jsonJobs[0].customer.id) {
          getPaymentLogs(jsonJobs[0].customer.id);
        }
        jsonJobs[0].customer.jobs.forEach((job, index) => {
          let dueDateSet = moment(TODAY, 'MM/DD/YYYY')
            .add(jsonJobs[0].customer.customerTerm, 'days')
            .format('MM/DD/YYYY');
          jsonJobs[0].customer.jobs[index].newDueDate = dueDateSet;
        });
      }

      if (jsonJobs && jsonJobs.length > 0) {
        if (jsonJobs[0].customer && jsonJobs[0].customer.jobs) {
          if (jsonJobs[0].customer.companyLogo) {
            jsonJobs[0].customer['blobResLOGO'] = jsonJobs[0].customer.companyLogo;
          }
        }
      }

      if (jsonJobs.msg) {
        setOpen(!open);
        setLoaderData(false);
        _showMessage(jsonJobs.msg);
        return;
      }
      _rows = jsonJobs;
      if (_rows && _rows.length > 0) {
        // const logo = await getImage(_rows[0].customer.companyLogo);
        let logo = null;
        if (_rows[0]?.customer?.companyLogo) {
          logo = _rows[0]?.customer?.companyLogo.includes('http')
            ? _rows[0].customer.companyLogo
            : `${constants.URLLOCAL}/aws/signed?image=${_rows[0].customer.companyLogo}`;
        }
        setLogoCompany(logo ? logo : 'assets/images/logos/loadzlogo.png');

        setTotable(_rows);

        const startDate = moment(info.dateCreated, 'YYYY-MM-DD');

        setDateStarted(info.dateCreated);
        const endDate = moment(info.dueDate, 'YYYY-MM-DD');
        const diffDays = moment.duration(endDate.diff(startDate)).asDays();
        setTerms(diffDays);
        setInvoiceNumber(info.invoice);
        setNotes(info.notes);
        setLoaderData(false);
        let dataWithSig = _rows;
        for (let j = 0; j < dataWithSig[0].customer.jobs.length; j++) {
          let tempIndex = 0;
          let ele = dataWithSig[0].customer.jobs[j];

          // if (waitStart.length === waitEnd.length) {
          //   let totalDuration = 0;
          //   waitStart.forEach((start, i) => {
          //     const startTime = moment(start);
          //     const endTime = moment(waitEnd[i]);
          //     // Intercambiamos el orden para evitar valores negativos
          //     const duration = moment.duration(Math.abs(endTime.diff(startTime)));
          //     totalDuration += duration.asHours();
          //   });
          //   return `${totalDuration.toFixed(2)}H`;
          // }
          let totalDuration = 0;
          if (ele.batches && ele.batches.length > 0) {
            for (let index = 0; index < ele.batches.length; index++) {
              let batch = ele.batches[index];
              console.log('Number(ele.waitrate)', Number(ele.waitrate));
              if (batch.info && batch.info.length > 0) {
                for (let i = 0; i < batch.info.length; i++) {
                  if (batch.info[i].waitStart && batch.info[i].waitEnd) {
                    if (batch.info[i].waitStart.length === batch.info[i].waitEnd.length) {
                      batch.info[i].waitStart.forEach((start, k) => {
                        const startTime = moment(start);
                        const endTime = moment(batch.info[i].waitEnd[k]);
                        const duration = moment.duration(Math.abs(endTime.diff(startTime)));
                        totalDuration += duration.asHours();
                      });
                      ele['calculateWaitTime'] = Number.isFinite(totalDuration)
                        ? totalDuration.toFixed(2)
                        : '0.00';
                    } else {
                      ele['calculateWaitTime'] = safeWaitHoursFromRate(
                        batch.info.reduce((total, item) => total + (Number(item.waitCR) || 0), 0),
                        ele.waitrate
                      );
                      // / Number(ele.waitrate)
                      let ticket = batch.info[i];
                      ticket.printIndex = tempIndex;
                      tempIndex++;
                      let data = {
                        key: ticket.tkSignature,
                      };
                      // let resp = await getDataFromS3(data);
                      // if (resp) {
                      //   batch.info[i].newSignUrl = resp.data.data.fileLocation;
                      //   let blobRes = await getImageBlobFromsignature(resp.data.data.fileLocation);
                      //   if (blobRes) {
                      //     batch.info[i]['blobUrl'] = blobRes;
                      //   }
                      // }
                    }
                  } else {
                    ele['calculateWaitTime'] = safeWaitHoursFromRate(
                      batch.info.reduce((total, item) => total + (Number(item.waitCR) || 0), 0),
                      ele.waitrate
                    );
                    let ticket = batch.info[i];
                    ticket.printIndex = tempIndex;
                    tempIndex++;
                    let data = {
                      key: ticket.tkSignature,
                    };
                    // let resp = await getDataFromS3(data);
                    // if (resp) {
                    //   batch.info[i].newSignUrl = resp.data.data.fileLocation;
                    //   let blobRes = await getImageBlobFromsignature(resp.data.data.fileLocation);
                    //   if (blobRes) {
                    //     batch.info[i]['blobUrl'] = blobRes;
                    //   }
                    // }
                  }
                }
              }
            }
          }
          if (ele.calculateWaitTime == null || ele.calculateWaitTime === '') {
            const fallback = Number(ele.jobTotalWaitTime);
            ele['calculateWaitTime'] = Number.isFinite(fallback) ? fallback.toFixed(2) : '0.00';
          }
        }
        setDataWithSignature(dataWithSig);
      }
    } catch (e) {
      setLoaderData(false);
      console.log('invoice preview error', e);
    }
  };

  const getPaymentLogs = async (client_id) => {
    const finalRoute =
      typeof compacctNumSub === 'string' && compacctNumSub.includes('-OP')
        ? `/payments/ops/get-payments/customer/${client_id}/${
            prop_data ? prop_data.compacctnum : user?.company?.compacctnum
          }/0/${compacctNumSub}/${info.invoice}`
        : `/payments/get-payments/customer/${client_id}/${
            prop_data ? prop_data.compacctnum : user?.company?.compacctnum
          }/0`;

    const payments = await client.get(finalRoute);
    if (payments.data) {
      const jsonPayments = payments?.data;
      let allPayment = [];
      jsonPayments &&
        jsonPayments?.payment &&
        jsonPayments?.payment?.length > 0 &&
        jsonPayments?.payment?.forEach((pd) => {
          if (pd.payments && pd.payments.length > 0) {
            let filterPayment = pd.payments.filter((pay) => pay.invoice_no == info.invoice);
            if (filterPayment && filterPayment.length > 0) {
              filterPayment.forEach((ftPay) => {
                if (allPayment.length == 0) {
                  allPayment.push(ftPay);
                } else {
                  let paymentIndex = allPayment.findIndex((alPay) => alPay.id == ftPay.id);
                  if (paymentIndex == -1) {
                    allPayment.push(ftPay);
                  }
                }
              });
            }
          }
        });
      setAllPayment(jsonPayments.payment);
    }
  };

  const getEmailLogsForCustomer = async (customer_id = null) => {
    const customerId = toTable[0]?.customer?.id ? toTable[0].customer.id : customer_id;
    if (!customerId) return;

    const finalRoute =
      typeof compacctNumSub === 'string' && compacctNumSub.includes('-OP')
        ? `/payments/ops/activity-logs/${customerId}/${
            prop_data ? prop_data?.compacctnum : user?.company?.compacctnum
          }/${info.invoice}/${compacctNumSub}`
        : `/payments/activity-logs/${customerId}/${
            prop_data ? prop_data?.compacctnum : user?.company?.compacctnum
          }/${info.invoice}`;

    let emailLogsData;
    try {
      emailLogsData = await client.get(finalRoute);
    } catch (e) {
      setEmailForPayment({ emailLogs: [], paymentsLog: [] });
      return;
    }

    // 204 / empty body → nothing to show
    if (!emailLogsData || emailLogsData.status === 204 || !emailLogsData.data) {
      setEmailForPayment({ emailLogs: [], paymentsLog: [] });
      return;
    }

    if (emailLogsData.status != 200) {
      setEmailForPayment({ emailLogs: [], paymentsLog: [] });
      return;
    }

    const paymentsLog = Array.isArray(emailLogsData.data.paymentsLog)
      ? emailLogsData.data.paymentsLog
      : [];

    let emailLogs = Array.isArray(emailLogsData.data.emailLogs)
      ? emailLogsData.data.emailLogs
      : [];

    if (emailLogs.length) {
      emailLogs = emailLogs.filter((item) => {
        if (item?.client_id === customerId && item?.invoice_no === info.invoice.toString()) {
          return true;
        }
        // OOP activity logs are keyed by invoice_id; keep rows without client/invoice_no match
        if (item?.invoice_id != null && !item?.client_id) return true;
        return false;
      });
    }

    if (emailLogs.length) {
      emailLogs = emailLogs.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

      emailLogs.forEach((emailLog, index) => {
        let filteredPayments = paymentsLog.filter(
          (payment) => new Date(payment.payment_date) > new Date(emailLog.created_at)
        );
        emailLog.paymentLogs = filteredPayments;
        if (index > 0) {
          emailLogs[index - 1].paymentLogs = emailLogs[index - 1].paymentLogs.filter(
            (x) => !emailLogs[index].paymentLogs.includes(x)
          );
        }
      });

      emailLogs.forEach((event) => {
        event.paymentLogs = orderBy(
          event.paymentLogs,
          (item) => moment(item?.payment_date).unix(),
          'asc'
        );
      });

      const nestedIds = new Set();
      emailLogs.forEach((e) => (e.paymentLogs || []).forEach((p) => nestedIds.add(p.id)));
      // Payments before any email (or otherwise not nested) still show in the timeline
      const orphanPayments = orderBy(
        paymentsLog.filter((p) => !nestedIds.has(p.id)),
        (item) => moment(item?.payment_date).unix(),
        'asc'
      );

      setEmailForPayment({ emailLogs, paymentsLog: orphanPayments });
    } else {
      // No email activity: still show partial/full payments on Invoice Activity
      setEmailForPayment({
        emailLogs: [],
        paymentsLog: orderBy(paymentsLog, (item) => moment(item?.payment_date).unix(), 'asc'),
      });
    }
  };

  const renderPaymentTimelineItems = (payments) => {
    if (!payments?.length) return null;
    return payments.map((element, index) => (
      <TimelineItem key={`pay-${element.id || element.pdid || index}`}>
        <TimelineSeparator>
          <TimelineDot />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent className='font-medium'>
          <p className='font-bold'>
            {t('PAYMENT_RECEIVED')}
            {paymentVoidReturnLabel(element) && (
              <span
                className='ml-8 px-6 rounded'
                style={{ backgroundColor: VOID_RETURN_BG, color: VOID_RETURN_COLOR, fontSize: '12px' }}
              >
                {paymentVoidReturnLabel(element)}
              </span>
            )}
          </p>
          <p className='my-4'>
            {moment(element.payment_date).format('MMMM Do YYYY, h:mm:ss a')}{' '}
          </p>
          <div className='flex pr-5'>
            <span>{t('AMOUNT_RECEIVED')}: </span>
            <p
              className='text-sm ml-4'
              style={paymentVoidReturnLabel(element) ? { textDecoration: 'line-through', color: VOID_RETURN_COLOR } : undefined}
            >{`${formatter.format(element.amount)}`}</p>
          </div>
          <p>{t('SERVICE_FEE')}: </p>
          {element.posted_by_name && (
            <p>
              {t('POSTED_BY', 'Posted By')}: <span className='font-bold'>{element.posted_by_name}</span>
            </p>
          )}
          <p>
            <button
              className='text-blue-700'
              style={{ color: 'blue' }}
              onClick={() => {
                openViewPaymentDialog(element);
              }}
            >
              {' '}
              {t('VIEW_PAYMENT_HASTAG')}
              {element.pdid}{' '}
            </button>
          </p>
        </TimelineContent>
      </TimelineItem>
    ));
  };

  const componentRef = useRef();

  const [openEmail, setOpenEmail] = useState(false);
  const [correctionOpen, setCorrectionOpen] = useState(false);
  const [correctionLoading, setCorrectionLoading] = useState(false);
  const [correctionApplying, setCorrectionApplying] = useState(null);
  const [correctionList, setCorrectionList] = useState([]);
  const [correctionChecked, setCorrectionChecked] = useState(false);
  const [correctionBannerDismissed, setCorrectionBannerDismissed] = useState(false);
  const [correctionConfirmOpen, setCorrectionConfirmOpen] = useState(false);
  const [correctionPendingRow, setCorrectionPendingRow] = useState(null);
  const [rateMismatchList, setRateMismatchList] = useState([]);
  const [rateMismatchConfirmOpen, setRateMismatchConfirmOpen] = useState(false);
  const [rateMismatchAsked, setRateMismatchAsked] = useState(false);
  const [rateMismatchApplying, setRateMismatchApplying] = useState(false);

  const isOwnerOperatorInvoice =
    (typeof compacctNumSub === 'string' && compacctNumSub.includes('-OP')) ||
    String(prop_data?.compacctnum || user?.company?.compacctnum || '').includes('-OP');

  const fetchInvoiceLastEditCorrections = async ({ openDialog = false } = {}) => {
    if (openDialog) setCorrectionOpen(true);
    setCorrectionLoading(true);
    try {
      const invoiceId = info?.id ?? info?.invoice_id ?? null;
      const body = invoiceId
        ? { invoice_id: invoiceId }
        : { ticket_ids: Array.isArray(tickets) ? tickets : [] };
      const result = await client.post('/ticket/preview-last-edit-correction', body);
      if (result?.data?.err_message) {
        if (openDialog) {
          _showMessage(result.data.err_message);
          setCorrectionOpen(false);
        }
        setCorrectionList([]);
        return;
      }
      const needing = result?.data?.needing_correction || [];
      setCorrectionList(needing);
      setCorrectionChecked(true);
    } catch (e) {
      if (openDialog) {
        _showMessage(e?.message || t('ERROR') || 'Error loading corrections');
        setCorrectionOpen(false);
      }
      setCorrectionList([]);
    } finally {
      setCorrectionLoading(false);
    }
  };

  const openLastEditCorrections = async () => {
    // Keep cached list when available; if empty (e.g. after banner dismiss was wrongly
    // clearing it) always re-fetch so Recover still shows pending corrections.
    if (correctionChecked && correctionList.length > 0) {
      setCorrectionOpen(true);
      return;
    }
    await fetchInvoiceLastEditCorrections({ openDialog: true });
  };

  useEffect(() => {
    if (!open || !isOwnerOperatorInvoice) {
      if (!open) {
        setCorrectionList([]);
        setCorrectionChecked(false);
        setCorrectionBannerDismissed(false);
        setCorrectionConfirmOpen(false);
        setCorrectionPendingRow(null);
        setCorrectionOpen(false);
      }
      return;
    }
    setCorrectionBannerDismissed(false);
    setCorrectionConfirmOpen(false);
    setCorrectionPendingRow(null);
    fetchInvoiceLastEditCorrections({ openDialog: false });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, isOwnerOperatorInvoice, info?.id, info?.invoice_id]);

  const correctionAuthPayload = () => ({
    user_id: prop_data
      ? prop_data.compacctnum
      : user?.staff
      ? user?.staff?.staff_u_id
      : user?.user_id,
    comp_acct: prop_data ? prop_data.compacctnum : user?.company?.compacctnum,
  });

  const fetchHaulingRateMismatches = async () => {
    if (isOwnerOperatorInvoice) {
      setRateMismatchList([]);
      return;
    }
    try {
      const invoiceId = info?.id ?? info?.invoice_id ?? null;
      const body = {
        ...correctionAuthPayload(),
        ...(invoiceId ? { invoice_id: invoiceId } : {}),
        ticket_ids: Array.isArray(tickets) ? tickets : [],
      };
      const result = await client.post('/ticket/preview-hauling-rate-correction', body);
      if (result?.data?.err_message) {
        setRateMismatchList([]);
        return;
      }
      setRateMismatchList(result?.data?.needing_correction || []);
    } catch (e) {
      setRateMismatchList([]);
    }
  };

  useEffect(() => {
    if (!open || isOwnerOperatorInvoice) {
      if (!open) {
        setRateMismatchList([]);
        setRateMismatchConfirmOpen(false);
        setRateMismatchAsked(false);
        setRateMismatchApplying(false);
      }
      return;
    }
    setRateMismatchAsked(false);
    setRateMismatchConfirmOpen(false);
    fetchHaulingRateMismatches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, isOwnerOperatorInvoice, info?.id, info?.invoice_id]);

  useEffect(() => {
    if (
      open &&
      !loaderData &&
      !isOwnerOperatorInvoice &&
      rateMismatchList.length > 0 &&
      !rateMismatchAsked
    ) {
      setRateMismatchConfirmOpen(true);
      setRateMismatchAsked(true);
    }
  }, [open, loaderData, rateMismatchList, isOwnerOperatorInvoice, rateMismatchAsked]);

  const applyHaulingRateMismatches = async () => {
    if (!rateMismatchList.length) {
      setRateMismatchConfirmOpen(false);
      return;
    }
    setRateMismatchApplying(true);
    try {
      const invoiceId = info?.id ?? info?.invoice_id ?? null;
      const result = await client.post('/ticket/apply-hauling-rate-correction', {
        ...correctionAuthPayload(),
        ticket_ids: rateMismatchList.map((row) => row.tk_id),
        ...(invoiceId ? { invoice_id: invoiceId } : {}),
        send_emails: false,
      });
      if (result?.data?.err_message) {
        _showMessage(result.data.err_message);
        return;
      }
      const errorCount = result?.data?.errors?.length || 0;
      if (errorCount) {
        _showMessage(
          t('INVOICE_RATE_MISMATCH_PARTIAL', {
            applied: result?.data?.applied?.length || 0,
            errors: errorCount,
          })
        );
      } else {
        dispatch(
          showMessage({
            message: t('INVOICE_RATE_MISMATCH_APPLIED', {
              count: result?.data?.applied?.length || rateMismatchList.length,
            }),
            autoHideDuration: 5000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
            variant: 'success',
          })
        );
      }
      setRateMismatchConfirmOpen(false);
      setRateMismatchList([]);
      await getData();
      applyInvoiceTotalsFromServer(result?.data?.invoice);
      await fetchHaulingRateMismatches();
    } catch (e) {
      _showMessage(e?.message || t('INVOICE_RATE_MISMATCH_ERROR'));
    } finally {
      setRateMismatchApplying(false);
    }
  };

  const dismissHaulingRateMismatches = () => {
    setRateMismatchConfirmOpen(false);
  };

  const applyInvoiceTicketCorrection = async (row) => {
    if (!row?.tk_id) return;
    setCorrectionApplying(row.tk_id);
    setCorrectionConfirmOpen(false);
    setCorrectionPendingRow(null);
    try {
      const result = await client.post('/ticket/apply-last-edit-correction', {
        tk_id: row.tk_id,
        user_id: prop_data
          ? prop_data.compacctnum
          : user?.staff
          ? user?.staff?.staff_u_id
          : user?.user_id,
        comp_acct: prop_data ? prop_data.compacctnum : user?.company?.compacctnum,
        is_op: true,
        send_emails: false,
      });
      if (result?.data?.err_message) {
        _showMessage(result.data.err_message);
        return;
      }
      dispatch(
        showMessage({
          message:
            i18n.language === 'es'
              ? `Ticket #${row.tk_no} corregido`
              : `Ticket #${row.tk_no} corrected`,
          autoHideDuration: 4000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
          variant: 'success',
        })
      );
      setCorrectionList((prev) => prev.filter((c) => c.tk_id !== row.tk_id));
      await getData();
      applyInvoiceTotalsFromServer(result?.data?.invoice);
    } catch (e) {
      _showMessage(e?.message || 'Error applying correction');
    } finally {
      setCorrectionApplying(null);
    }
  };

  /** Persist last-edit corrections (only after confirm dialog). */
  const applyAllInvoiceCorrections = async () => {
    const rows = [...correctionList];
    if (!rows.length) return;
    setCorrectionApplying('all');
    setCorrectionConfirmOpen(false);
    setCorrectionPendingRow(null);
    try {
      // Last response holds the invoice totals after every correction was applied.
      let result;
      for (const row of rows) {
        result = await client.post('/ticket/apply-last-edit-correction', {
          tk_id: row.tk_id,
          user_id: prop_data
            ? prop_data.compacctnum
            : user?.staff
            ? user?.staff?.staff_u_id
            : user?.user_id,
          comp_acct: prop_data ? prop_data.compacctnum : user?.company?.compacctnum,
          is_op: true,
          send_emails: false,
        });
        if (result?.data?.err_message) {
          _showMessage(`Ticket #${row.tk_no}: ${result.data.err_message}`);
        }
      }
      setCorrectionList([]);
      setCorrectionBannerDismissed(false);
      await getData();
      applyInvoiceTotalsFromServer(result?.data?.invoice);
      await fetchInvoiceLastEditCorrections({ openDialog: false });
      dispatch(
        showMessage({
          message:
            i18n.language === 'es'
              ? 'Correcciones aplicadas. El invoice se actualizó.'
              : 'Corrections applied. Invoice refreshed.',
          autoHideDuration: 5000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
          variant: 'success',
        })
      );
    } catch (e) {
      _showMessage(e?.message || 'Error applying corrections');
    } finally {
      setCorrectionApplying(null);
    }
  };

  /**
   * Banner ✓ only opens the confirm dialog — never persists tickets.
   * Persist happens only from confirmPendingCorrections ("Yes, edit").
   */
  const openBannerCorrectionConfirm = () => {
    if (!correctionList.length) return;
    setCorrectionPendingRow(null);
    setCorrectionOpen(false);
    setCorrectionBannerDismissed(false);
    setCorrectionConfirmOpen(true);
  };

  /**
   * Accept / Accept all: show proposed values on the invoice,
   * restore the banner if X hid it, then ask for confirmation before editing tickets.
   * Does not persist until user confirms in the dialog.
   */
  const previewThenConfirmCorrections = (row = null) => {
    if (row) {
      if (!row?.tk_id) return;
      setCorrectionPendingRow(row);
    } else {
      if (!correctionList.length) return;
      setCorrectionPendingRow(null);
    }
    setCorrectionOpen(false);
    setCorrectionBannerDismissed(false);
    setCorrectionConfirmOpen(true);
  };

  const confirmPendingCorrections = async () => {
    if (correctionPendingRow) {
      await applyInvoiceTicketCorrection(correctionPendingRow);
      return;
    }
    await applyAllInvoiceCorrections();
  };

  const rateMismatchTicketNos = useMemo(() => {
    const ids = new Set();
    rateMismatchList.forEach((row) => {
      if (row.tk_no != null) ids.add(Number(row.tk_no));
      if (row.tk_id != null) ids.add(Number(row.tk_id));
    });
    return ids;
  }, [rateMismatchList]);

  /** Preview invoice lines with proposed last-edit values (before check / confirm persists them). */
  const displayToTable = useMemo(() => {
    // X dismisses banner and restores the original receipt until preview is shown again.
    if (!toTable?.length || !correctionList?.length || correctionBannerDismissed) return toTable;
    const byId = new Map(correctionList.map((c) => [Number(c.tk_id), c]));
    const byNo = new Map(correctionList.map((c) => [Number(c.tk_no), c]));

    return toTable.map((block) => {
      if (!block?.customer?.jobs) return block;
      return {
        ...block,
        customer: {
          ...block.customer,
          jobs: block.customer.jobs.map((job) => {
            let jobTotalHauling = 0;
            const batches = (job.batches || []).map((batch) => {
              const info = (batch.info || []).map((ticket) => {
                const corr =
                  byId.get(Number(ticket.ticketId)) || byNo.get(Number(ticket.ticket));
                if (!corr?.proposed) {
                  jobTotalHauling += Number(ticket.ticketCR) || 0;
                  return ticket;
                }
                const qty =
                  corr.proposed.tk_qty != null ? Number(corr.proposed.tk_qty) : ticket.qty;
                const ticketCR =
                  corr.proposed.ticket_cr != null
                    ? Number(corr.proposed.ticket_cr)
                    : ticket.ticketCR;
                jobTotalHauling += Number(ticketCR) || 0;
                return { ...ticket, qty, ticketCR };
              });
              return { ...batch, info };
            });
            return { ...job, batches, jobTotalHauling };
          }),
        },
      };
    });
  }, [toTable, correctionList, correctionBannerDismissed]);

  const TableToTable = displayToTable[0]?.customer?.jobs[0]?.batches[0];

  const applyInvoiceTotalsFromServer = (invoice) => {
    if (!invoice) return;
    const balance = invoice.invoice_balance ?? invoice.balance;
    const total = invoice.invoice_total_amount ?? invoice.total;
    const id = invoice.id ?? invoice.invoice_id;
    setInfoData((prev) => ({
      ...(prev || info || {}),
      id: id ?? prev?.id,
      invoice_id: id ?? prev?.invoice_id,
      balance,
      total,
    }));
    if (typeof onInvoiceUpdated === 'function') {
      onInvoiceUpdated({
        id,
        invoiceId: id,
        invoice_no: invoice.invoice_no ?? info?.invoice,
        balance,
        total,
        hauling: invoice.unit_package_value ?? invoice.hauling,
        material: invoice.material_package_vale ?? invoice.material,
        wait: invoice.waittime_package_value ?? invoice.wait,
        taxesMaterial: invoice.material_tax ?? invoice.taxesMaterial,
      });
    }
  };

  const previewBalanceDue = useMemo(() => {
    const storedBalanceRaw = infoData?.balance ?? info?.balance;
    const storedTotalRaw = infoData?.total ?? info?.total;

    const sumJobTotals = (jobs, includeFuel) =>
      (jobs || []).reduce(
        (sum, job) =>
          sum +
          (Number(job.jobTotalHauling) || 0) +
          (includeFuel ? jobFuelSurchargeTotal(job) : 0) +
          (Number(job.jobTotalMaterial) || 0) +
          (Number(job.jobTotalWait) || 0),
        0
      );

    if (
      !correctionBannerDismissed &&
      correctionList?.length &&
      displayToTable?.[0]?.customer?.jobs
    ) {
      const previewTotal = sumJobTotals(displayToTable[0].customer.jobs, false);
      const originalJobs = toTable?.[0]?.customer?.jobs;

      // Keep payments/discounts already baked into info.balance; only shift by
      // the delta between original ticket totals and last-edit preview totals.
      // (Previously this returned previewTotal alone → Balance Due = Sub Total
      // and partial payments disappeared, e.g. $16,830 instead of $5,830.)
      if (storedBalanceRaw != null && originalJobs?.length) {
        const originalTotal = sumJobTotals(originalJobs, false);
        const currentBalance = changeCurrency(String(storedBalanceRaw));
        if (Number.isFinite(currentBalance)) {
          return formatter.format(currentBalance + (previewTotal - originalTotal));
        }
      }

      return formatter.format(previewTotal);
    }

    const jobs = displayToTable?.[0]?.customer?.jobs || toTable?.[0]?.customer?.jobs;
    if (jobs?.length) {
      const liveTotal = sumJobTotals(jobs, true);
      const storedTotal = changeCurrency(String(storedTotalRaw ?? ''));
      const storedBalance = changeCurrency(String(storedBalanceRaw ?? ''));
      // Payments and discounts stay in the stored invoice. Fuel on the tickets
      // is added here so a clone that gained surcharge updates Balance Due.
      if (
        Number.isFinite(liveTotal) &&
        Number.isFinite(storedTotal) &&
        Number.isFinite(storedBalance)
      ) {
        return formatter.format(liveTotal - (storedTotal - storedBalance));
      }
      if (Number.isFinite(liveTotal)) {
        return formatter.format(liveTotal);
      }
    }

    return storedBalanceRaw;
  }, [
    correctionBannerDismissed,
    correctionList,
    displayToTable,
    toTable,
    info?.balance,
    info?.total,
    infoData?.balance,
    infoData?.total,
  ]);

  const emailhandleOpen = () => {
    getEmailLogsForCustomer();
    setOpenEmail(false);
  };
  useEffect(() => {
    // setNotes(Array(uniqueJobs.length).fill(''))
    // setDiscounts(Array(uniqueJobs.length).fill(0));
    setDiscounts(info.discount ? info.discount.toFixed(2) : 0);
  }, [uniqueJobs]);

  const [storeLogo, setStoreLogo] = useState(null);
  const getS3Location = async (key) => {
    if (key != null && key != '') {
      let data = {
        key: store.getState().photo,
      };
      return await getDataFromS3(data);
    }
  };

  useEffect(async () => {
    let key = user?.company?.logo;
    if (logo) {
      key = logo;
    }
    let logoRes = await getS3Location(key);
    if (logoRes && logoRes.data && logoRes.data.data) {
      logoRes.data.data.logoKey = key;
      setStoreLogo(logoRes.data.data);
    }
  }, [user?.company?.logo]);

  async function getImageBlobFromUrl(url) {
    try {
      const image = await axios
        .get(url, {
          responseType: 'blob',
        })
        .then((response) => window.URL.createObjectURL(new Blob([response.data])));
      return image;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  React.useEffect(async () => {
    if (storeLogo && storeLogo.fileLocation) {
      const image = await getImageBlobFromUrl(storeLogo.fileLocation);
      setBlobLogoForUNVoice(image);
    }
  }, [storeLogo]);

  async function getImageBlobFromsignature(url) {
    try {
      const image = await axios
        .get(url, {
          responseType: 'blob',
        })
        .then((response) => window.URL.createObjectURL(new Blob([response.data])));
      return image;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const calculateDuration = (totalVal, waitVal, waitStart, waitEnd) => {
    if (waitStart && waitEnd) {
      if (waitStart.length === waitEnd.length) {
        let totalDuration = 0;
        waitStart.forEach((start, i) => {
          const startTime = moment(start);
          const endTime = moment(waitEnd[i]);
          // Intercambiamos el orden para evitar valores negativos
          const duration = moment.duration(Math.abs(endTime.diff(startTime)));
          totalDuration += duration.asHours();
        });
        return formatWaitHours(totalDuration);
      } else {
        return formatWaitHours(safeWaitHoursFromRate(waitVal, totalVal));
      }
    } else {
      return formatWaitHours(safeWaitHoursFromRate(waitVal, totalVal));
    }
  };

  const calculateRate = (waitrate, waitCR, waitStart, waitEnd) => {
    if (waitStart && waitEnd) {
      if (waitStart.length === waitEnd.length) {
        let totalDuration = 0;
        waitStart.forEach((start, i) => {
          const startTime = moment(start);
          const endTime = moment(waitEnd[i]);
          // Intercambiamos el orden para evitar valores negativos
          const duration = moment.duration(Math.abs(endTime.diff(startTime)));
          totalDuration += duration.asHours();
        });

        const calculateDurationRes = Number(waitCR) / Number(totalDuration);

        // Calcular el porcentaje de diferencia
        const diffPercent =
          (Math.abs(calculateDurationRes - Number(waitrate)) / Number(waitrate)) * 100;

        if (diffPercent > 2.5) {
          return `${calculateDurationRes.toFixed(2)}`;
        } else {
          return `${Number(waitrate).toFixed(2)}`;
        }
      }
    }
  };

  return (
    <div>
      <BootstrapDialog
        maxWidth={'xl'}
        // onClose={() => handleOpen(open)}
        aria-labelledby='customized-dialog-title'
        open={open}
        fullWidth={true}
        className={loaderData ? 'customloader' : ''}
      >
        {loaderData ? (
          <div>
            <FuseLoading />
          </div>
        ) : (
          <>
            <BootstrapDialogTitle id='customized-dialog-title' onClose={() => handleOpen(open)}>
              <Box display='flex' alignItems='center' flexWrap='wrap' style={{ gap: 10 }}>
                <span>{isOwnerOpsView ? t('OOP_STATEMENT_OF_WORK') : t('PREVIEW_INVOICES')}</span>
                {isOwnerOperatorInvoice &&
                  correctionChecked &&
                  !correctionBannerDismissed &&
                  correctionList.length > 0 && (
                    <Box
                      component='span'
                      display='inline-flex'
                      alignItems='center'
                      style={{
                        color: '#5c3b00',
                        backgroundColor: 'rgba(237,202,51,0.45)',
                        borderRadius: 4,
                        padding: '2px 4px 2px 8px',
                        gap: 2,
                      }}
                    >
                      <Typography
                        component='span'
                        variant='body2'
                        style={{
                          fontWeight: 600,
                          fontSize: 12,
                        }}
                      >
                        {i18n.language === 'es'
                          ? `Valor actual no sincronizado con última edición (${correctionList.length})`
                          : `Current value not synced with last edit (${correctionList.length})`}
                      </Typography>
                      <IconButton
                        size='small'
                        onClick={openBannerCorrectionConfirm}
                        disabled={!!correctionApplying}
                        style={{ padding: 2, color: '#1b5e20' }}
                        title={
                          i18n.language === 'es'
                            ? 'Confirmar y aplicar correcciones'
                            : 'Confirm and apply corrections'
                        }
                      >
                        {correctionApplying === 'all' ? (
                          <CircularProgress size={14} />
                        ) : (
                          <CheckIcon style={{ fontSize: 18 }} />
                        )}
                      </IconButton>
                      <IconButton
                        size='small'
                        onClick={() => {
                          setCorrectionBannerDismissed(true);
                          setCorrectionConfirmOpen(false);
                          setCorrectionPendingRow(null);
                        }}
                        style={{ padding: 2, color: '#5c3b00' }}
                        title={
                          i18n.language === 'es'
                            ? 'Cerrar aviso y ver recibo original'
                            : 'Dismiss notice and show original receipt'
                        }
                      >
                        <CloseIcon style={{ fontSize: 16 }} />
                      </IconButton>
                    </Box>
                  )}
              </Box>
              <div className='invoicePrintbtns' style={{ marginTop: '15px', gap: 10 }}>
                <ReactToPrint
                  trigger={() => (
                    <div style={{ marginRight: 0 }}>
                      <button className='invoicePrintbtn' type='button'>
                        <img
                          width='20px'
                          height='20px'
                          src='/assets/images/icons/print-icon-white.svg'
                        />
                      </button>
                    </div>
                  )}
                  content={() => componentRef.current}
                />
                <>
                  {/* <PDFDownloadLink
                  document={<ModelCustomPdf toTable={toTable} />}
                  fileName={"PDF_REPORT.pdf"}
                  >{({ blob, url, loading, error }) =>
                  loading ? "Report loading..." : "Report ready to download"
                }
                </PDFDownloadLink> */}
                  {/* {dataForPDF && dataForPDF.length > 0 ? 
                  <PDFDownloadLink
                    document={
                      <ModelCustomPdf
                        toTable={dataForPDF}
                        compName={compName}
                        TableToTable={TableToTable}
                        invoiceDueDate={info.dueDate}
                        notes={notes}
                        blobLogoForUNVoice={blobLogoForUNVoice}
                        invoiceNumber={invoiceNumber}
                        infoData={infoData}
                        newLogo={logo}
                        terms={terms}
                        dateStarted={dateStarted}
                        info={info}
                      />
                    }
                    fileName={`${TableToTable?.info[0]?.job}-${
                      TableToTable?.info[0]?.job.length > 0
                        ? invoiceNumber + 1
                        : invoiceNumber
                    }-${moment().format("MM/DD/YYYY hh:mm:ss")}`}
                  >
                    <div
                      className="invoicePrintbtn"
                      style={{ marginRight: "0" }}
                    >
                      <img
                        width="20px"
                        height="20px"
                        src="/assets/images/icons/pdf-icon-white.svg"
                      />
                    </div>
                  </PDFDownloadLink> : 
                  <div
                      className="invoicePrintbtn"
                      style={{ marginRight: "0" }}
                    >
                      <CircularProgress  color="success"/>
                    </div>
                  } */}
                </>
                <div
                  className='invoicePrintbtn'
                  onClick={() => setOpenEmail(true)}
                  style={{ marginRight: 0 }}
                >
                  <img width='20px' height='20px' src='/assets/images/icons/email-icon-white.svg' />
                </div>
                {isOwnerOperatorInvoice && (
                  <Tooltip
                    title={
                      i18n.language === 'es'
                        ? 'Recuperar último valor editado por ticket'
                        : 'Recover last edited values per ticket'
                    }
                  >
                    <div
                      className='invoicePrintbtn'
                      onClick={openLastEditCorrections}
                      style={{ marginRight: 0 }}
                    >
                      <RefreshIcon style={{ color: '#fff', width: 24, height: 24 }} />
                    </div>
                  </Tooltip>
                )}
              </div>
            </BootstrapDialogTitle>
            <DialogContent dividers>
              <div className='flex w-full max-w-screen-sx customer-left-bar xl:flex-row lg:flex-row md:flex-row sm:flex-col flex-col'>
                <div className='xl:w-1/3 lg:w-1/3 md:w-1/3   sm:w-full w-full justify-center items-center'>
                  <Card
                    component={motion.div}
                    variants={item}
                    style={{
                      border: '0',
                      borderRadius: '0',
                      padding: '0',
                      boxShadow: 'none',
                    }}
                  >
                    <Paper
                    // style={{ maxHeight: 750, overflow: 'auto' }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          paddingRight: '30px',
                          paddingLeft: '20px',
                          paddingTop: '10px',
                        }}
                      >
                      </Box>
                    </Paper>
                  </Card>
                  <Card
                    ref={componentRef}
                    component={motion.div}
                    variants={item}
                    style={{
                      border: '1px solid #eacd2f',
                      borderRadius: '10',
                      padding: '30px',
                      boxShadow: 'none',
                    }}
                  >
                    <Paper className='InvoicesPrints left-bals shadow-none Invoices-nw pyment-box-td'>
                      {displayToTable[0]?.customer?.jobs?.map((job, index) => (
                        <div id={`pdf-invoice-${job.job}`}>
                          <Grid
                            className='mainpdfview'
                            container
                            spacing={2}
                            style={{ padding: '10px' }}
                          >
                            <Grid className='cstPdf' item xs={12}>
                              <Grid container spacing={2}>
                                <Typography
                                  variant='h5'
                                  gutterBottom
                                  component='div'
                                  className='text-sm font-medium w-full'
                                  style={{ fontSize: '15px' }}
                                >
                                  {t('BALANCE_DUE')}
                                </Typography>
                                <Typography
                                  variant='h4'
                                  gutterBottom
                                  component='div'
                                  className='m-0 sub-title w-full'
                                  style={{ fontSize: '20px', lineHeight: '1' }}
                                >
                                  {previewBalanceDue}
                                </Typography>
                                <div className='mt-32 w-full'>
                                  <Typography
                                    variant='h5'
                                    gutterBottom
                                    component='div'
                                    className='text-sm font-medium w-full'
                                    style={{ fontSize: '15px' }}
                                  >
                                    {t('DUE_DATE')}
                                  </Typography>
                                  <Typography
                                    variant='h4'
                                    gutterBottom
                                    component='div'
                                    className='m-0 sub-title w-full'
                                    style={{
                                      fontSize: '18px',
                                      lineHeight: '1',
                                    }}
                                  >
                                    {moment(info.dueDate).format('MM/DD/YYYY')}
                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        </div>
                      ))}
                    </Paper>
                  </Card>
                  <Box className=' w-full pyment-box mt-16'>
                    <Typography
                      variant='h5'
                      gutterBottom
                      component='div'
                      className='text-sm font-medium w-full text-center mb-16'
                      style={{
                        fontSize: '16px',
                        paddingBottom: '15px',
                        borderBottom: '1px solid #eacd2f',
                      }}
                    >
                      {t('INVOICE_ACTIVITY')}
                    </Typography>

                    <Timeline
                      sx={{
                        [`& .${timelineItemClasses.root}:before`]: {
                          flex: 0,
                          padding: 0,
                        },
                      }}
                    >
                      <TimelineItem>
                        <TimelineSeparator>
                          <TimelineDot />
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent className='font-medium'>
                          <p className='font-bold'>{t('OPENED')} </p>
                          {moment(info.dateCreated).format('MM/DD/YYYY')}
                        </TimelineContent>
                      </TimelineItem>

                      {emailForPayment &&
                        emailForPayment.emailLogs &&
                        emailForPayment.emailLogs.map((event, index) => {
                          return (
                            <div key={index}>
                              <TimelineItem>
                                <TimelineSeparator>
                                  <TimelineDot />
                                  <TimelineConnector />
                                </TimelineSeparator>
                                {(event?.log_type == 'INVOICE_SENT' || !event?.log_type) && (
                                  <TimelineContent className='font-medium'>
                                    <p className='font-bold'>
                                      {t('INVOICE_EMAIL_SENT_TO')}{' '}
                                      <span style={{ color: 'blue' }}>
                                        {event?.send_to ? event?.send_to : ''}{' '}
                                      </span>{' '}
                                      {t('ON')}{' '}
                                    </p>

                                    {/* {moment(event.created_at).format("MM/DD/YYYY")} */}
                                    {moment(event.created_at).format('MMMM Do YYYY, h:mm:ss a')}
                                    {(event?.sent_by_name || event?.source === 'system') && (
                                      <p className='text-sm'>
                                        {t('SENT_BY', 'Sent by')}:{' '}
                                        <span className='font-bold'>
                                          {event?.sent_by_name
                                            ? event.sent_by_name
                                            : t('SENT_AUTOMATICALLY', 'Loadz (automatic)')}
                                        </span>
                                      </p>
                                    )}
                                  </TimelineContent>
                                )}
                                {event?.log_type == 'INVOICE_SEEN' && (
                                  <TimelineContent className='font-medium'>
                                    <p className='font-bold'>{t('INVOICE_SEEN_ON')}</p>

                                    {/* {moment(event.created_at).format("MM/DD/YYYY")} */}
                                    {moment(event.created_at).format('MMMM Do YYYY, h:mm:ss a')}
                                  </TimelineContent>
                                )}
                              </TimelineItem>
                              <>{renderPaymentTimelineItems(event.paymentLogs)}</>
                            </div>
                          );
                        })}

                      {/* Partial/full payments when there is no email log (or orphans not nested under an email) */}
                      {renderPaymentTimelineItems(emailForPayment?.paymentsLog)}

                      <TimelineItem>
                        <TimelineSeparator>
                          <TimelineDot />
                        </TimelineSeparator>
                        <TimelineContent className='font-bold'>{t('STATUS')}</TimelineContent>
                      </TimelineItem>
                    </Timeline>

                    {activeStep === steps.length && (
                      <Paper square elevation={0} sx={{ p: 3 }}>
                        <Typography>{t('ALL_STEPS_COMPLETED_MESSAGE')}</Typography>
                        <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
                          {t('RESET')}
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </div>

                <div className='w-full ModalGenerateInvoicesPrints' style={{ padding: '10px' }}>
                  <Card
                    ref={componentRef}
                    component={motion.div}
                    variants={item}
                    style={{
                      // border: "0",
                      // borderRadius: "0",
                      padding: '20px',
                      // boxShadow: "none",
                    }}
                  >
                    <Paper className='InvoicesPrints Invoices-nw'>
                      {displayToTable[0]?.customer?.jobs?.map((job, index) => (
                        <div id={`pdf-invoice-${job.job}`} className='pdf_new'>
                          <Grid
                            className='mainpdfview'
                            container
                            spacing={2}
                            style={{ padding: '10px' }}
                          >
                            <Grid className='cstPdf' item xs={12}>
                              <Grid container spacing={2}>
                                <Grid item xs={6} sx={{ margin: 'auto' }}>
                                  <img
                                    className='w-full-s company-logo'
                                    src={logoCompany}
                                    alt='logo'
                                  />
                                  <Typography variant='body1'>{compName}</Typography>
                                  <Typography variant='body1'>
                                    {job.comp_address}, {job.comp_city}, {job.comp_state},{' '}
                                    {job.comp_zip}
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} sx={{ textAlign: 'end' }}>
                                  <Typography
                                    variant='h2'
                                    gutterBottom
                                    component='div'
                                    className='font-bold m-0 mb-10 uppercase big-title'
                                    style={{ fontSize: '45px' }}
                                  >
                                    {t('INVOICE_HASTAG')}{' '}
                                    {index === 0 ? invoiceNumber : invoiceNumber + index}
                                  </Typography>
                                  {/* <Typography variant="h6" gutterBottom component="div">Invoice Date: {moment(info.dateCreated).format('MM/DD/YYYY')}</Typography> */}
                                  <Typography
                                    variant='h5'
                                    gutterBottom
                                    component='div'
                                    className='flex justify-end items-end text-sm font-bold'
                                    style={{ fontSize: '16px' }}
                                  >
                                    {t('TOTAL')}:{' '}
                                    <Typography
                                      variant='h4'
                                      gutterBottom
                                      component='div'
                                      className='font-bold m-0 ml-10 sub-title'
                                      style={{
                                        fontSize: '25px',
                                        lineHeight: '1',
                                      }}
                                    >
                                      {formatter.format(
                                        (job?.jobTotalHauling ? job.jobTotalHauling : 0) +
                                          jobFuelSurchargeTotal(job) +
                                          (job?.jobTotalMaterial ? job?.jobTotalMaterial : 0) +
                                          (job?.jobTotalWait ? job?.jobTotalWait : 0)
                                        //  +
                                        // (job.jobTotalTaxesMaterial
                                        //   ? job.jobTotalTaxesMaterial
                                        //   : 0)
                                      )}
                                    </Typography>
                                  </Typography>
                                  {/* <Typography variant="body1" >Terms: {terms}</Typography>
                                    <Typography variant="body1" >Due Date: {moment(info.dueDate).format('MM/DD/YYYY')}</Typography>
                                    <Typography variant="body1" ></Typography>
                                    <Typography variant="body1" >Hauling Total: {formatter.format(job.jobTotalHauling)}</Typography>
                                    <Typography variant="body1" >Material Total: {formatter.format(job.jobTotalMaterial)}</Typography>
                                  <Typography variant="body1" >Wait Charge: {formatter.format(job.jobTotalWait)}</Typography> */}
                                </Grid>
                              </Grid>
                              <Grid container spacing={3}>
                                <Grid item xs={4} sx={{ margin: 'auto' }}>
                                  <Typography variant='body1' className='font-bold'>
                                    {t('BILL_TO')}:
                                  </Typography>
                                  <Typography variant='body1'>
                                    {toTable[0]?.customer?.customerName}
                                  </Typography>
                                  <Typography variant='body1'>
                                    {toTable[0]?.customer?.locationId},
                                    {toTable[0]?.customer?.customerCity},
                                    {toTable[0]?.customer?.customerState},
                                    {toTable[0]?.customer?.customerZip}
                                  </Typography>
                                </Grid>
                                <Grid item xs={4} sx={{ margin: 'auto' }}>
                                  {job?.po && (
                                    <div>
                                      <Typography variant='body1'>
                                        <strong className='font-bold'>
                                          {t('PURCHASE_ORDER')}:{' '}
                                        </strong>
                                        {job?.po}
                                      </Typography>
                                    </div>
                                  )}
                                  <Typography variant='body1'>
                                    <strong className='font-bold'>{t('JOB_NO')}: </strong>
                                    {job.job}
                                    <OriginalJobLabel job={job} variant='inline' />
                                  </Typography>

                                  <Typography variant='body1'>
                                    <strong className='font-bold'>{t('JOB_SITE')}: </strong>
                                    {job.jobDestination}
                                  </Typography>
                                  <Typography variant='body1'>
                                    <strong className='font-bold'>{t('ORIGIN')}: </strong>
                                    {job.jobQuarry}
                                  </Typography>
                                </Grid>
                                <Grid item xs={4} sx={{ textAlign: 'end' }}>
                                  <Typography variant='body1'>
                                    {t('DATE')}: {moment(info.dateCreated).format('MM/DD/YYYY')}
                                  </Typography>
                                  <Typography variant='body1'>
                                    {t('TERMS')}: {terms ? Number(terms).toFixed(0) : 0}
                                  </Typography>
                                  <Typography variant='body1'>
                                    {t('DUE_DATE')}: {moment(info.dueDate).format('MM/DD/YYYY')}
                                  </Typography>
                                </Grid>
                              </Grid>

                              {/* <br />
                                <Divider />
                              <br></br> */}

                              <Grid container>
                                {/* <Grid item xs={4} >
                                    <Typography variant="h6" gutterBottom component="div">
                                    Customer:
                                    </Typography>
                                    <Typography variant="body1" >
                                    {toTable[0]?.customer?.customerName}
                                    </Typography>
                                    <Typography variant="body1" >
                                    {toTable[0]?.customer?.locationId},{toTable[0]?.customer?.customerCity},{toTable[0]?.customer?.customerState},{toTable[0]?.customer?.customerZip}
                                    </Typography>
                                  </Grid> */}

                                {/* <Grid item xs={4}
                                    sx={{
                                      textAlign: 'center'
                                    }}>
                                    <Typography variant="h6" gutterBottom component="div">
                                      {`Project (Job Name):`}
                                    </Typography>
                                    <Typography variant="body1" >
                                    {job.jobDestination}
                                    </Typography>
                                    <Typography variant="body1" >
                                    Job No.: {job.job}
                                    </Typography>
                                  </Grid> */}

                                {/* <Grid item xs={4}
                                    sx={{
                                      textAlign: 'end'
                                    }}>
                                    <Typography variant="h6" gutterBottom component="div">
                                    {`Origin / Source:`}
                                    </Typography>
                                    <Typography variant="body1" >
                                    {job.jobQuarry}
                                    </Typography>
                                  </Grid> */}
                              </Grid>

                              <>
                                {job.batches.map((batch) => (
                                  <>
                                    <br></br>
                                    <Divider style={{ border: '1px solid #ccc' }}></Divider>
                                    <br />

                                    <Grid container className='topbatchno'>
                                      <Grid item xs={4}>
                                        <Typography variant='body1'>
                                          {t('BATCH_NO')}: {batch.batch}
                                        </Typography>
                                      </Grid>

                                      <Grid item xs={4}>
                                        <Typography variant='body1' style={{ textAlign: 'center' }}>
                                          {t('DATE')}:{batch.batchDateTimeReal}
                                        </Typography>
                                      </Grid>

                                      <Grid item xs={4}>
                                        <Typography variant='body1' style={{ textAlign: 'right' }}>
                                          {t('MATERIAL')}: {batch.material}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                    {/* <br></br>
                                        <Divider style={{border: '1px solid #000',}}></Divider> */}
                                    <br></br>
                                    <Grid container>
                                      <Grid item xs={12} className='newinvoice-ui'>
                                        <Paper
                                          sx={{
                                            width: '100%',
                                            borderRadius: '0',
                                            boxShadow: 'none',
                                          }}
                                        >
                                          <Table
                                            style={{
                                              width: '100%',
                                              tableLayout: 'auto',
                                              border: '1px solid #000',
                                              borderCollapse: 'collapse',
                                            }}
                                          >
                                            <TableBody>
                                              {[t('HAULING'), t('MATERIAL'), t('WAIT_CHARGE')].map(
                                                (type, typeIndex) => (
                                                  <>
                                                    <></>
                                                    {batch.info.map((ticket, i) => (
                                                      <>
                                                        {batch.info.length + 1 === i + 1 ? (
                                                          <></>
                                                        ) : (
                                                          <>
                                                            {typeIndex === 0 ? (
                                                              <>
                                                                {i === 0 &&
                                                                  batch.info.some(
                                                                    (x) => x.ticketCR > 0
                                                                  ) && (
                                                                    <>
                                                                      <TableRow key={typeIndex}>
                                                                        <TableCell
                                                                          align='left'
                                                                          width='100%'
                                                                          colSpan={
                                                                            batch.info.some(
                                                                              (x) =>
                                                                                x?.fuel_surcharge !=
                                                                                null
                                                                            )
                                                                              ? 10
                                                                              : 9
                                                                          }
                                                                          style={{
                                                                            fontWeight: 'bold',
                                                                            fontSize: '25px',
                                                                            padding: '10px 10px',
                                                                            border:
                                                                              '1px solid #000',
                                                                          }}
                                                                        >
                                                                          {type}
                                                                        </TableCell>
                                                                      </TableRow>
                                                                      <TableHead
                                                                        width='100%'
                                                                        style={{
                                                                          display: 'contents',
                                                                        }}
                                                                      >
                                                                        <TableRow>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('TICKET_NO')}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('SCALE_NO_DOT')}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('TRUCK')}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {rateColumnLabel}
                                                                          </TableCell>
                                                                          {batch.info.some(
                                                                            (x) =>
                                                                              x?.fuel_surcharge !=
                                                                              null
                                                                          ) ? (
                                                                            <TableCell
                                                                              align='center'
                                                                              width='11.11%'
                                                                            >
                                                                              FSC
                                                                            </TableCell>
                                                                          ) : null}
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('QTY')}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('UNIT')}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('TAX_UPPER')}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('TOTAL')}
                                                                          </TableCell>
                                                                          {/* <TableCell align="center" width="11.11%">Type</TableCell> */}
                                                                        </TableRow>
                                                                      </TableHead>
                                                                    </>
                                                                  )}
                                                                {ticket.ticketCR &&
                                                                ticket.ticketCR > 0 ? (
                                                                  <TableRow
                                                                    key={ticket.ticket}
                                                                    style={
                                                                      rateMismatchTicketNos.has(
                                                                        Number(ticket.ticket)
                                                                      ) ||
                                                                      rateMismatchTicketNos.has(
                                                                        Number(ticket.ticketId)
                                                                      )
                                                                        ? {
                                                                            outline:
                                                                              '2px solid #d32f2f',
                                                                            backgroundColor:
                                                                              'rgba(211,47,47,0.06)',
                                                                          }
                                                                        : undefined
                                                                    }
                                                                  >
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {ticket.ticket}
                                                                    </TableCell>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {ticket.scale}
                                                                    </TableCell>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {ticket.truck}
                                                                    </TableCell>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {invoiceTicketHaulingRate(
                                                                        ticket,
                                                                        job.jobUnitRate
                                                                      )}
                                                                    </TableCell>
                                                                    {batch.info.some(
                                                                      (x) =>
                                                                        x?.fuel_surcharge != null
                                                                    ) ? (
                                                                      <TableCell
                                                                        align='center'
                                                                        width='11.11%'
                                                                      >
                                                                        {ticket.fuel_surcharge !=
                                                                        null
                                                                          ? formatter.format(
                                                                              Number(
                                                                                ticket.fuel_surcharge
                                                                                  .amount
                                                                              ) || 0
                                                                            )
                                                                          : ''}
                                                                      </TableCell>
                                                                    ) : null}
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {ticket.qty}
                                                                    </TableCell>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {typeIndex != 2
                                                                        ? batch.unit
                                                                        : 'H'}
                                                                    </TableCell>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {'N'}
                                                                    </TableCell>

                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {formatter.format(
                                                                        (Number(ticket.ticketCR) ||
                                                                          0) +
                                                                          (ticket.fuel_surcharge !=
                                                                          null
                                                                            ? Number(
                                                                                ticket.fuel_surcharge
                                                                                  .amount
                                                                              ) || 0
                                                                            : 0)
                                                                      )}
                                                                    </TableCell>
                                                                    {/* <TableCell align="center" width="11.11%">{type}</TableCell> */}
                                                                  </TableRow>
                                                                ) : null}
                                                              </>
                                                            ) : typeIndex === 1 ? (
                                                              <>
                                                                {i === 0 &&
                                                                  batch.info.some(
                                                                    (x) => x.materialCR > 0
                                                                  ) && (
                                                                    <>
                                                                      <TableRow key={typeIndex}>
                                                                        <TableCell
                                                                          align='left'
                                                                          width='100%'
                                                                          colSpan={9}
                                                                          style={{
                                                                            fontWeight: 'bold',
                                                                            fontSize: '25px',
                                                                            padding: '10px 10px',
                                                                            border:
                                                                              '1px solid #000',
                                                                          }}
                                                                        >
                                                                          {type}
                                                                        </TableCell>
                                                                      </TableRow>
                                                                      <TableHead
                                                                        width='100%'
                                                                        style={{
                                                                          display: 'contents',
                                                                        }}
                                                                      >
                                                                        <TableRow>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('TICKET_NO')}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('SCALE_NO_DOT')}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('TRUCK')}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {rateColumnLabel}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('QTY')}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('UNIT')}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('TAX_UPPER')}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('TOTAL')}
                                                                          </TableCell>
                                                                          {/* <TableCell align="center" width="11.11%">Type</TableCell> */}
                                                                        </TableRow>
                                                                      </TableHead>
                                                                    </>
                                                                  )}
                                                                {ticket.materialCR &&
                                                                ticket.materialCR > 0 ? (
                                                                  <TableRow key={ticket.ticket}>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {ticket.ticket}
                                                                    </TableCell>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {ticket.scale}
                                                                    </TableCell>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {ticket.truck}
                                                                    </TableCell>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {job.jobMaterialRate}
                                                                    </TableCell>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {ticket.qty}
                                                                    </TableCell>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {typeIndex != 2
                                                                        ? batch.unit
                                                                        : 'H'}
                                                                    </TableCell>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {job.jobTaxable ? 'T' : 'N'}
                                                                    </TableCell>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {formatter.format(
                                                                        ticket.materialCR
                                                                      )}
                                                                    </TableCell>
                                                                    {/* <TableCell align="center" width="11.11%">{type}</TableCell> */}
                                                                  </TableRow>
                                                                ) : null}
                                                              </>
                                                            ) : typeIndex === 2 ? (
                                                              <>
                                                                {i === 0 &&
                                                                  batch.info.some(
                                                                    (x) => x.waitCR > 0
                                                                  ) && (
                                                                    <>
                                                                      <TableRow key={typeIndex}>
                                                                        <TableCell
                                                                          align='left'
                                                                          width='100%'
                                                                          colSpan={9}
                                                                          style={{
                                                                            fontWeight: 'bold',
                                                                            fontSize: '25px',
                                                                            padding: '10px 10px',
                                                                            border:
                                                                              '1px solid #000',
                                                                          }}
                                                                        >
                                                                          {type}
                                                                        </TableCell>
                                                                      </TableRow>
                                                                      <TableHead
                                                                        width='100%'
                                                                        style={{
                                                                          display: 'contents',
                                                                        }}
                                                                      >
                                                                        <TableRow>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('TICKET_NO')}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('SCALE_NO_DOT')}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('TRUCK')}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {rateColumnLabel}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('DURATION')}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('UNIT')}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('TAX_UPPER')}
                                                                          </TableCell>
                                                                          <TableCell
                                                                            align='center'
                                                                            width='11.11%'
                                                                          >
                                                                            {t('TOTAL')}
                                                                          </TableCell>
                                                                          {/* <TableCell align="center" width="11.11%">Type</TableCell> */}
                                                                        </TableRow>
                                                                      </TableHead>
                                                                    </>
                                                                  )}
                                                                {ticket.waitCR &&
                                                                ticket.waitCR > 0 ? (
                                                                  <TableRow key={ticket.ticket}>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {ticket.ticket}
                                                                    </TableCell>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {ticket.scale}
                                                                    </TableCell>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {ticket.truck}
                                                                    </TableCell>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {calculateRate(
                                                                        job.waitrate,
                                                                        ticket.waitCR,
                                                                        ticket.waitStart,
                                                                        ticket.waitEnd
                                                                      )}
                                                                    </TableCell>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {calculateDuration(
                                                                        job.waitrate,
                                                                        ticket.waitCR,
                                                                        ticket.waitEnd,
                                                                        ticket.waitStart
                                                                      )}
                                                                    </TableCell>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {'H'}
                                                                    </TableCell>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {'N'}
                                                                    </TableCell>
                                                                    <TableCell
                                                                      align='center'
                                                                      width='11.11%'
                                                                    >
                                                                      {formatter.format(
                                                                        ticket.waitCR
                                                                      )}
                                                                    </TableCell>
                                                                    {/* <TableCell align="center" width="11.11%">{type}</TableCell> */}
                                                                  </TableRow>
                                                                ) : null}
                                                              </>
                                                            ) : (
                                                              <></>
                                                            )}
                                                          </>
                                                        )}
                                                      </>
                                                    ))}
                                                  </>
                                                )
                                              )}

                                              {/* <TableRow>
                                                    <TableCell>Sub Totals</TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell align="center">{`${Number(batch.qtyTotal).toFixed(2)}`}</TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell align="center">{`${formatter.format(batch.totalMaterialCost + batch.totalTicketCost + batch.totalWaitTime)}`}</TableCell>
                                                    <TableCell></TableCell>
                                                  </TableRow> */}
                                            </TableBody>
                                          </Table>
                                        </Paper>
                                      </Grid>
                                    </Grid>
                                  </>
                                ))}
                              </>
                              <br></br>
                              {/* <Grid container>
                                  <Grid item xs={12}>
                                    <Paper sx={{ width: '100%', borderRadius:'0', boxShadow: 'none' }}>
                                      <Table className='table-bottom' style={{ width: "100%", tableLayout: "auto" }}>
                                        <TableBody>
                                          <TableRow>
                                            <TableCell align='center' width="11.11%"></TableCell>
                                            <TableCell align='center' width="11.11%"></TableCell>
                                            <TableCell align='center' width="11.11%"></TableCell>
                                            <TableCell align='center' width="11.11%"></TableCell>
                                            <TableCell align='center' width="11.11%"></TableCell>

                                            <TableCell align='center' width="11.11%"></TableCell>
                                            <TableCell align='center' width="11.11%">Total QTY</TableCell>

                                            <TableCell align="center" width="22.22%">{`${Number(job.jobTotalTickets).toFixed(2)}`}</TableCell>

                                            <TableCell align='center' width="0%"></TableCell>
                                          </TableRow>

                                          <TableRow>
                                            <TableCell align='center' width="11.11%"></TableCell>
                                            <TableCell align='center' width="11.11%"></TableCell>
                                            <TableCell align='center' width="11.11%"></TableCell>
                                            <TableCell align='center' width="11.11%"></TableCell>
                                            <TableCell align='center' width="11.11%"></TableCell>

                                            <TableCell align='center' width="11.11%"></TableCell>
                                            <TableCell align='center' width="11.11%">Total Wait Time</TableCell>

                                            <TableCell align="center" width="22.22%">{`${Number(job.jobTotalWaitTime).toFixed(2)}`} H</TableCell>

                                            <TableCell align='center' width="0%"></TableCell>
                                          </TableRow>

                                          <TableRow>
                                            <TableCell align="center" width="11.11%"></TableCell>
                                            <TableCell align="center" width="11.11%"></TableCell>
                                            <TableCell align="center" width="11.11%"></TableCell>
                                            <TableCell align="center" width="11.11%"></TableCell>
                                            <TableCell align="center" width="11.11%"></TableCell>

                                            <TableCell align="center" width="0%"></TableCell>
                                            <TableCell align="center" width="22.22%">Sub Total Invoice</TableCell>

                                            <TableCell align="center" width="22.22%">{`${formatter.format(
                                              job.jobTotalHauling + (job.jobTotalMaterial - job.jobTotalTaxesMaterial) + job.jobTotalWait
                                            )}`}</TableCell>

                                            <TableCell align="center" width="0%"></TableCell>
                                          </TableRow>

                                          <TableRow>
                                            <TableCell align='center' width="11.11%"></TableCell>
                                            <TableCell align='center' width="11.11%"></TableCell>
                                            <TableCell align='center' width="11.11%"></TableCell>
                                            <TableCell align='center' width="11.11%"></TableCell>
                                            <TableCell align='center' width="11.11%"></TableCell>

                                            <TableCell align='center' width="0%"></TableCell>
                                            <TableCell align='center' width="22.22%">Tax {job.jobTaxable ? job.jobTax > 0 || job.jobTax ? job.jobTax : `8.25%` : 0}% Material</TableCell>

                                            <TableCell align="center" width="22.22%">{`${formatter.format(
                                              job.jobTotalTaxesMaterial
                                            )}`}</TableCell>

                                            <TableCell align='center' width="0%"></TableCell>
                                          </TableRow>

                                          <TableRow>
                                            <TableCell align='center' width="11.11%"></TableCell>
                                            <TableCell align='center' width="11.11%"></TableCell>
                                            <TableCell align='center' width="11.11%"></TableCell>
                                            <TableCell align='center' width="11.11%"></TableCell>
                                            <TableCell align='center' width="11.11%"></TableCell>

                                            <TableCell align='center' width="11.11%"></TableCell>
                                            <TableCell align='center' width="11.11%">Total Invoice</TableCell>

                                            <TableCell align="center" width="22.22%">{`${formatter.format(
                                              job.jobTotalHauling + job.jobTotalMaterial + job.jobTotalWait
                                            )}`}</TableCell>

                                            <TableCell align='center' width="0%"></TableCell>
                                          </TableRow>
                                        </TableBody>
                                      </Table>
                                    </Paper>
                                  </Grid>
                                </Grid> */}
                              <br></br>
                              {/* <div className='page-break'></div> */}
                              <Grid container spacing={2} className='new-invoice-bottmtable'>
                                <Grid item xs={7} className='new-invoice-bottmleft'>
                                  <Typography variant='body1'>{t('NOTES_TO_CUSTOMER')}:</Typography>
                                  <Typography variant='body1' sx={{ wordBreak: 'break-all' }}>
                                    {' '}
                                    {notes}{' '}
                                  </Typography>
                                </Grid>
                                <Grid item xs={5} className='new-invoice-bottmright'>
                                  <Table>
                                    <TableRow>
                                      <TableCell align='left'>{t('TICKET_COUNT')}</TableCell>
                                      <TableCell align='left'>{`${Number(
                                        job.jobTotalTickets
                                      ).toFixed(2)}`}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell align='left'>{t('TOTAL_QTY')}</TableCell>
                                      <TableCell align='left'>
                                        {`${job.batches
                                          .reduce(
                                            (total, batch) => total + (Number(batch.qtyTotal) || 0),
                                            0
                                          )
                                          .toFixed(2)}`}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell align='left'>{t('TOTAL_WAIT_TIME')}</TableCell>
                                      <TableCell align='left'>
                                        {formatWaitHours(
                                          job?.calculateWaitTime ?? job?.jobTotalWaitTime ?? 0
                                        )}
                                      </TableCell>
                                      {/* {`${Number(
                                          job &&
                                            job.calculateWaitTime &&
                                            Number(job.calculateWaitTime) / Number(job.waitrate)
                                        ).toFixed(2)}`} */}
                                    </TableRow>
                                    <TableRow>
                                      <TableCell align='left'>{t('SUB_TOTAL_INVOICE')}</TableCell>
                                      <TableCell align='left'>{`${formatter.format(
                                        (job.jobTotalHauling ? job.jobTotalHauling : 0) +
                                          jobFuelSurchargeTotal(job) +
                                          ((job.jobTotalMaterial ? job.jobTotalMaterial : 0) -
                                            (job.jobTotalTaxesMaterial
                                              ? job.jobTotalTaxesMaterial
                                              : 0)) +
                                          (job.jobTotalWait ? job.jobTotalWait : 0)
                                      )}`}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell align='left'>
                                        Tax{' '}
                                        {job.jobTaxable
                                          ? job.jobTax > 0 || job.jobTax
                                            ? job.jobTax
                                            : `8.25%`
                                          : 0}
                                        {t('PERCENT_MATERIAL')}
                                      </TableCell>
                                      <TableCell align='left'>{`${formatter.format(
                                        job.jobTotalTaxesMaterial ? job.jobTotalTaxesMaterial : 0
                                      )}`}</TableCell>
                                    </TableRow>

                                    {info && info.balance ? (
                                      <TableRow>
                                        <TableCell align='left' style={{ fontWeight: 'bold' }}>
                                          {t('BALANCE_DUE')}
                                        </TableCell>
                                        <TableCell align='left' style={{ fontWeight: 'bold' }}>
                                          {previewBalanceDue}
                                        </TableCell>
                                      </TableRow>
                                    ) : (
                                      <TableRow>
                                        <TableCell align='left' style={{ fontWeight: 'bold' }}>
                                          {t('TOTAL_INVOICE')}
                                        </TableCell>
                                        <TableCell
                                          align='left'
                                          style={{ fontWeight: 'bold' }}
                                        >{`${formatter.format(
                                          (job.jobTotalHauling ? job.jobTotalHauling : 0) +
                                            jobFuelSurchargeTotal(job) +
                                            (job.jobTotalMaterial ? job.jobTotalMaterial : 0) +
                                            (job.jobTotalWait ? job.jobTotalWait : 0)
                                        )}`}</TableCell>
                                      </TableRow>
                                    )}
                                  </Table>
                                </Grid>
                              </Grid>
                              <br></br>
                              <Grid container>
                                <Grid
                                  item
                                  xs={12}
                                  sx={{
                                    textAlign: '-webkit-right',
                                  }}
                                  className='flex justify-end items-end'
                                >
                                  <Typography variant='h6' style={{ fontSize: '14px' }}>
                                    {t('POWERED_BY')}
                                  </Typography>
                                  <img
                                    className='pdf_lodz_logo'
                                    src='assets/images/logos/loadzlogo.png' //TODO Configurable Variable.
                                    alt='logo'
                                  />
                                </Grid>
                              </Grid>
                              <br></br>
                              <br></br>
                              <Divider style={{ border: '1px solid #ccc' }}></Divider>
                              <br></br>
                            </Grid>
                          </Grid>
                          {/* <div className='break-before-all'></div>
                            <div className='break-after-all'></div> */}
                        </div>
                      ))}
                    </Paper>
                  </Card>
                </div>
              </div>
            </DialogContent>

            <DialogActions>
              {/* {true &&
                <Button autoFocus onClick={() => sendData()}>
                  Generate
                </Button>
              } */}
              <Button autoFocus onClick={() => handleOpen(open)}>
                Close
              </Button>
            </DialogActions>
            {openEmail ? (
              <ModelInvoiceEmail
                prop_data={prop_data}
                open={openEmail}
                emailhandleOpen={emailhandleOpen}
                toTable={toTable}
                invoiceDate={info.dateCreated}
                infoData={infoData}
                compName={compName}
                invoiceNo={invoiceNumber}
                terms={terms}
                tickets={tickets}
                info={info}
                allPayment={allPayment}
                compacctNumSub={compacctNumSub}
              />
            ) : null}

            <Dialog
              open={correctionOpen}
              onClose={() => setCorrectionOpen(false)}
              maxWidth='md'
              fullWidth
            >
              <DialogTitle>
                {i18n.language === 'es'
                  ? 'Correcciones desde última edición'
                  : 'Corrections from last edit'}
              </DialogTitle>
              <DialogContent dividers>
                {correctionLoading ? (
                  <Box display='flex' justifyContent='center' p={3}>
                    <CircularProgress size={28} />
                  </Box>
                ) : correctionList.length === 0 ? (
                  <Typography>
                    {i18n.language === 'es'
                      ? 'No hay tickets que necesiten corrección en este invoice.'
                      : 'No tickets need correction on this invoice.'}
                  </Typography>
                ) : (
                  correctionList.map((row) => (
                    <Box
                      key={row.tk_id}
                      sx={{
                        borderBottom: '1px solid #eee',
                        py: 1.5,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        gap: 2,
                      }}
                    >
                      <Box>
                        <Typography variant='subtitle1' fontWeight='bold'>
                          Ticket #{row.tk_no}
                        </Typography>
                        {(row.changes || []).map((c) => (
                          <Typography
                            key={c.field}
                            variant='body2'
                            color='textSecondary'
                            style={{ fontWeight: 700 }}
                          >
                            {c.label}: {c.from == null ? '—' : String(c.from)} →{' '}
                            {c.to == null ? '—' : String(c.to)}
                          </Typography>
                        ))}
                      </Box>
                      <Button
                        variant='contained'
                        style={{ backgroundColor: '#edca33', color: '#000', minWidth: 100 }}
                        disabled={!!correctionApplying}
                        onClick={() => previewThenConfirmCorrections(row)}
                      >
                        {i18n.language === 'es' ? 'Aceptar' : 'Accept'}
                      </Button>
                    </Box>
                  ))
                )}
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setCorrectionOpen(false)}>{t('CANCEL')}</Button>
                {correctionList.length > 1 && (
                  <Button
                    style={{ backgroundColor: '#edca33', color: '#000' }}
                    disabled={!!correctionApplying}
                    onClick={() => previewThenConfirmCorrections()}
                  >
                    {i18n.language === 'es' ? 'Aceptar todos' : 'Accept all'}
                  </Button>
                )}
              </DialogActions>
            </Dialog>
          </>
        )}

        {viewPaymentData && toTable && toTable.length ? (
          <PaymentDialog
            prop_data={prop_data}
            isOpen={isViewPaymentOpened}
            paymentData={viewPaymentData}
            closeModal={closeDialog}
            toTable={toTable}
            ClientName={ClientName}
            paymentReceiptData={paymentReceiptData}
          />
        ) : null}
      </BootstrapDialog>

      {/* Outside invoice modal so confirm is always visible above it */}
      <Dialog
        open={correctionConfirmOpen}
        onClose={() => {
          setCorrectionConfirmOpen(false);
          setCorrectionPendingRow(null);
        }}
        maxWidth='sm'
        fullWidth
        sx={{ zIndex: (theme) => theme.zIndex.modal + 10 }}
      >
        <DialogTitle>
          {i18n.language === 'es' ? 'Confirmar correcciones' : 'Confirm corrections'}
        </DialogTitle>
        <DialogContent dividers>
          <Typography>
            {correctionPendingRow
              ? i18n.language === 'es'
                ? `Se muestran los valores propuestos en el invoice. ¿Seguro que desea editar el ticket #${correctionPendingRow.tk_no}?`
                : `Proposed values are shown on the invoice. Are you sure you want to edit ticket #${correctionPendingRow.tk_no}?`
              : i18n.language === 'es'
              ? `Se muestran los valores propuestos en el invoice. ¿Seguro que desea editar ${correctionList.length} ticket(s)?`
              : `Proposed values are shown on the invoice. Are you sure you want to edit ${correctionList.length} ticket(s)?`}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setCorrectionConfirmOpen(false);
              setCorrectionPendingRow(null);
            }}
          >
            {t('CANCEL')}
          </Button>
          <Button
            style={{ backgroundColor: '#edca33', color: '#000' }}
            disabled={!!correctionApplying}
            onClick={confirmPendingCorrections}
          >
            {correctionApplying ? (
              <CircularProgress size={18} />
            ) : i18n.language === 'es' ? (
              'Sí, editar'
            ) : (
              'Yes, edit'
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={rateMismatchConfirmOpen}
        onClose={dismissHaulingRateMismatches}
        maxWidth='sm'
        fullWidth
        sx={{ zIndex: (theme) => theme.zIndex.modal + 10 }}
      >
        <DialogTitle>{t('INVOICE_RATE_MISMATCH_TITLE')}</DialogTitle>
        <DialogContent dividers>
          <Typography style={{ marginBottom: 12 }}>
            {t('INVOICE_RATE_MISMATCH_INTRO')}
          </Typography>
          {rateMismatchList.map((row) => (
            <Typography key={row.tk_id} variant='body2' style={{ fontWeight: 600, marginBottom: 6 }}>
              {t('INVOICE_RATE_MISMATCH_TICKET', {
                no: row.tk_no,
                from: formatter.format(Number(row.current?.tk_rate) || 0),
                to: formatter.format(Number(row.proposed?.tk_rate) || 0),
                fromCr: formatter.format(Number(row.current?.ticket_cr) || 0),
                toCr: formatter.format(Number(row.proposed?.ticket_cr) || 0),
              })}
            </Typography>
          ))}
          <Typography style={{ marginTop: 12 }}>{t('INVOICE_RATE_MISMATCH_CONFIRM')}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={dismissHaulingRateMismatches} disabled={rateMismatchApplying}>
            {t('CANCEL')}
          </Button>
          <Button
            style={{ backgroundColor: '#edca33', color: '#000' }}
            disabled={rateMismatchApplying}
            onClick={applyHaulingRateMismatches}
          >
            {rateMismatchApplying ? (
              <CircularProgress size={18} />
            ) : (
              t('INVOICE_RATE_MISMATCH_CORRECT')
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    user: state.loadz_auth?.AuthReducer?.user,
  };
};
export default connect(mapStateToProps, null)(ModalGenerateInvoices);
